module.exports = __webpack_public_path__ + "public/img/homeSel.341549e1.png";